import { useEffect, useState } from 'react'

// Single source of truth for the staff-only evaluation debug mode: storage key + same-tab event.
export const CHANNEL_MARKUP_EVALUATION_STORAGE_KEY = 'channel-markup-evaluation-mode'
export const CHANNEL_MARKUP_EVALUATION_MODE_CHANGED_EVENT = 'channel-markup-evaluation-mode-changed'
const SHOW_EVALUATIONS_VALUE = 'show-evaluations'

// Set/clear the debug mode and notify live subscribers.
export function setChannelMarkupEvaluationMode(enabled: boolean) {
  if (typeof window === 'undefined') {
    return
  }
  if (enabled) {
    window.localStorage.setItem(CHANNEL_MARKUP_EVALUATION_STORAGE_KEY, SHOW_EVALUATIONS_VALUE)
  } else {
    window.localStorage.removeItem(CHANNEL_MARKUP_EVALUATION_STORAGE_KEY)
  }
  window.dispatchEvent(new Event(CHANNEL_MARKUP_EVALUATION_MODE_CHANGED_EVENT))
}

// Reactively read the debug mode; re-renders on same-tab (custom event) or cross-tab (storage) changes.
export function useChannelMarkupEvaluationEnabled() {
  const [enabled, setEnabled] = useState(() => typeof window !== 'undefined' && window.localStorage.getItem(CHANNEL_MARKUP_EVALUATION_STORAGE_KEY) === SHOW_EVALUATIONS_VALUE)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined
    }
    const handleStorage = () => {
      setEnabled(window.localStorage.getItem(CHANNEL_MARKUP_EVALUATION_STORAGE_KEY) === SHOW_EVALUATIONS_VALUE)
    }

    window.addEventListener('storage', handleStorage)
    window.addEventListener(CHANNEL_MARKUP_EVALUATION_MODE_CHANGED_EVENT, handleStorage as EventListener)
    return () => {
      window.removeEventListener('storage', handleStorage)
      window.removeEventListener(CHANNEL_MARKUP_EVALUATION_MODE_CHANGED_EVENT, handleStorage as EventListener)
    }
  }, [])

  return enabled
}
